module.exports = __webpack_public_path__ + "static/media/clock.0506e19a.png";